import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import BrowseEvents from "./pages/BrowseEvents";
import EventDetail from "./pages/EventDetail";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import InfluencerSignup from "./pages/InfluencerSignup";
import MyTickets from "./pages/MyTickets";
import InfluencerDashboard from "./pages/InfluencerDashboard";
import CreateEvent from "./pages/CreateEvent";
import EditEvent from "./pages/EditEvent";
import Following from "./pages/Following";
import CreatorProfile from "./pages/CreatorProfile";
import LikedEvents from "./pages/LikedEvents";
import TeamDashboard from "./pages/TeamDashboard";
import ProfileSettings from "./pages/ProfileSettings";
import AuthCallback from "./pages/AuthCallback";
import AdminPanel from "./pages/AdminPanel";
import OwnerDashboard from "./pages/OwnerDashboard";
import ResaleMarketplace from "./pages/ResaleMarketplace";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import TicketScanner from "./pages/TicketScanner";
import TicketVerify from "./pages/TicketVerify";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import AgencySignup from "./pages/AgencySignup";
import AgencyLogin from "./pages/AgencyLogin";
import AgencyDashboard from "./pages/AgencyDashboard";
import "./App.css";
// Initialize i18n
import "./i18n";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<LandingPage />} />
            <Route path="events" element={<BrowseEvents />} />
            <Route path="events/:eventId" element={<EventDetail />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="influencer-signup" element={<InfluencerSignup />} />
            <Route path="my-tickets" element={<MyTickets />} />
            <Route path="following" element={<Following />} />
            <Route path="liked-events" element={<LikedEvents />} />
            <Route path="team-dashboard" element={<TeamDashboard />} />
            <Route path="creator/:username" element={<CreatorProfile />} />
            <Route path="dashboard" element={<InfluencerDashboard />} />
            <Route path="create-event" element={<CreateEvent />} />
            <Route path="events/:eventId/edit" element={<EditEvent />} />
            <Route path="settings" element={<ProfileSettings />} />
            <Route path="admin" element={<AdminPanel />} />
            <Route path="resale" element={<ResaleMarketplace />} />
            <Route path="auth/callback" element={<AuthCallback />} />
            <Route path="payment/success" element={<PaymentSuccess />} />
            <Route path="payment/cancel" element={<PaymentCancel />} />
            <Route path="scanner" element={<TicketScanner />} />
            <Route path="scanner/:eventId" element={<TicketScanner />} />
            <Route path="ticket/verify/:qrCode" element={<TicketVerify />} />
            <Route path="harptom" element={<OwnerDashboard />} />
            <Route path="agency/signup" element={<AgencySignup />} />
            <Route path="agency/login" element={<AgencyLogin />} />
            <Route path="agency/dashboard" element={<AgencyDashboard />} />
            <Route path=":username" element={<CreatorProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
